"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageCenter = void 0;
var util_1 = require("../../../util");
var websocket_channel_1 = require("../../../websocket-channel");
var connect_status_manager_interface_1 = require("../connect-status-manager/connect-status-manager.interface");
var receiver_1 = require("../receiver/receiver");
var sender_1 = require("../sender/sender");
var feature_1 = require("../../../feature");
var message_queue_1 = require("../message-queue/message-queue");
var message_classification_1 = require("../message-queue/message-classification");
var type_1 = require("../../../base/type");
var timeout_checker_1 = require("./timeout-checker");
var message_creater_1 = require("./message-creater");
var collab_room_reporter_1 = __importDefault(require("../../../report/collab-room-reporter"));
var MessageCenter = /** @class */ (function () {
    function MessageCenter(options, dependency, connectManager) {
        var _this = this;
        var _a, _b;
        this.options = options;
        this.dependency = dependency;
        this.connectManager = connectManager;
        this.tag = 'MessageCenter';
        this.limitFrequencyManager = new feature_1.LimitFrequencyManager(this.dependency);
        (_b = (_a = this.options.config) === null || _a === void 0 ? void 0 : _a.messagePriority) === null || _b === void 0 ? void 0 : _b.forEach(function (value, key) {
            _this.limitFrequencyManager.setPriority(key, value);
        });
        var bigCollabCommonDependency = {
            getServerParams: function () { return _this.serverRequestParams; },
            reconnect: function (reason) { return _this.reconnect(reason); },
            disconnect: function (reason) { return _this.connectManager.disconnect(reason); },
            isDisconnected: function () { return _this.connectManager.isDisconnected(); },
            handleServerMessage: function (message) { return _this.handleServerMessage(message); },
            onConnectSuccess: function () { return _this.connectManager.onConnectSuccess(); },
        };
        this.sender = new sender_1.Sender({
            getServerParams: function () { return _this.serverRequestParams; },
            isConnected: function () { return _this.connectManager.isConnected(); },
            onMessageSending: function (message) { return _this.onMessageSending(message); },
            onMessageWaiting: function (message) { return _this.onMessageWaiting(message); },
        });
        this.receiver = new receiver_1.Receiver(bigCollabCommonDependency);
        var messageClassification = new message_classification_1.MessageClassification([
            ["CURSOR_MESSAGE" /* CURSOR_MESSAGE */, message_classification_1.MessageSendType.PARALLEL],
        ]);
        this.messageSendQueue = new message_queue_1.MessageSendQueue(messageClassification);
        this.timeoutChecker = new timeout_checker_1.TimeoutChecker(this.messageSendQueue, {
            trySendMessage: function () { return _this.trySendMessage(); },
        });
        this.initOnConnectEvent();
    }
    MessageCenter.prototype.dispose = function () {
        this.receiver.dispose();
        this.sender.dispose();
        this.timeoutChecker.dispose();
    };
    MessageCenter.prototype.sendMessage = function (message) {
        util_1.ConnectionLog.info(this.tag + " sendMessage cmd:" + message.cmd + " taskId:" + message.taskId);
        if (this.messageSendQueue.has(message.taskId)) {
            util_1.ConnectionLog.warn(this.tag + " sendMessage taskId:" + message.taskId + " is sending.");
            message.onError(message.taskId, message.cmd, message.data, {
                errCode: websocket_channel_1.RoomErrorCode.EXIST,
                errMsg: 'msg already exist.',
            });
            return;
        }
        var bigCollabMessage = message_creater_1.MessageCreater.createMessage(message, this.options, this.dependency);
        this.messageSendQueue.add(bigCollabMessage);
        this.trySendMessage();
    };
    MessageCenter.prototype.cancelSendMessageByTaskId = function (taskId) {
        util_1.ConnectionLog.info("cancelSendMessageByTaskId taskId:" + taskId);
        this.messageSendQueue.remove(taskId);
    };
    MessageCenter.prototype.initOnConnectEvent = function () {
        var _this = this;
        this.connectManager.onConnectEvent(function (result) {
            var _a;
            var status = result.status, serverRequestParams = result.serverRequestParams;
            util_1.ConnectionLog.debug("onConnectEvent: " + status);
            var connectCallBackEventMap = new Map([
                ["" + connect_status_manager_interface_1.ConnectStatus.LOGINED, function () { return _this.handleLogined(serverRequestParams); }],
                ["" + connect_status_manager_interface_1.ConnectStatus.CONNECTED, function () { return _this.trySendMessage(); }],
                ["" + connect_status_manager_interface_1.ConnectStatus.DISCONNECT, function () { return _this.handleDisconnect(); }],
                ["" + connect_status_manager_interface_1.ConnectStatus.WAIT_RECONNECTING, function () { return _this.handleWaitReconnecting(); }],
            ]);
            // 事件触发业务回调
            if (connectCallBackEventMap.has(result.status)) {
                (_a = connectCallBackEventMap.get(result.status)) === null || _a === void 0 ? void 0 : _a();
            }
        });
    };
    MessageCenter.prototype.trySendMessage = function () {
        if (this.connectManager.isDisconnected()) {
            this.triggerAllMessagesShutdown();
            return;
        }
        this.trySendParallelMessage();
        this.trySendSerialMessage();
    };
    MessageCenter.prototype.trySendSerialMessage = function () {
        if (this.messageSendQueue.isCommittingSerialMessage()) {
            // 有正在发送中的串行数据
            return;
        }
        if (this.connectManager.isDisconnected()) {
            this.triggerAllMessagesShutdown();
            return;
        }
        var nextSerialMessage = this.messageSendQueue.nextSerialMessage();
        if (!nextSerialMessage) {
            // 已经没有待发送的串行数据了
            return;
        }
        this.sendBigCollabMessage(nextSerialMessage);
    };
    MessageCenter.prototype.trySendParallelMessage = function () {
        var _this = this;
        var messages = this.messageSendQueue.nextParallelMessages();
        messages.forEach(function (message) { return _this.sendBigCollabMessage(message); });
    };
    MessageCenter.prototype.sendBigCollabMessage = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.onMessageSending(message);
                        this.timeoutChecker.startCheckSendTimeout();
                        return [4 /*yield*/, this.sender.sendMessage(message)];
                    case 1:
                        result = _a.sent();
                        this.handleMessageResult(message, result);
                        return [2 /*return*/];
                }
            });
        });
    };
    MessageCenter.prototype.onMessageSending = function (message) {
        message.state = websocket_channel_1.MessageState.SENDING;
        message.lastSendTime = Date.now();
        message.retryCount += 1;
    };
    MessageCenter.prototype.onMessageWaiting = function (message) {
        message.state = websocket_channel_1.MessageState.WAITING;
    };
    MessageCenter.prototype.handleMessageResult = function (message, response) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                if (!response) {
                    // 当前 save 没有返回 response，说明在等待重连或者发起重连中
                    return [2 /*return*/];
                }
                // 同步提交处理
                if (message.syncCommit) {
                    this.handleSyncMessage(message, response);
                    return [2 /*return*/];
                }
                result = {
                    errCode: response.retcode,
                    errMsg: response.msg,
                    response: response.data.syncResult ? util_1.JsonUtil.parseJson(response.data.syncResult) : response,
                };
                this.handleMessageResultSend(message, result);
                return [2 /*return*/];
            });
        });
    };
    MessageCenter.prototype.handleSyncMessage = function (message, response) {
        var _this = this;
        if (response.retcode !== 0) {
            var head = {
                task_id: message.taskId,
                type: websocket_channel_1.MessageWaitAcceptCmd.COMMIT_ERROR,
            };
            var body = {
                data: __assign(__assign({}, response), { 
                    // 兼容下行数据和 ws
                    reason: response.retcode }),
            };
            this.handleMessageResultSendAccept(head, body);
            return;
        }
        // 同步处理
        var serverMessageList = this.parseSyncMessageResult(message, response);
        serverMessageList.forEach(function (serverMessage) {
            _this.handleServerMessage(serverMessage);
        });
    };
    /**
     * 解析同步返回数据，生成 head，body 结构
     */
    MessageCenter.prototype.parseSyncMessageResult = function (message, response) {
        // 同步提交一定有syncResult字段，没有则抛错异常
        if (!response.data.syncResult) {
            throw Error("Save Response Error, syncResult is undefined, taskId: " + message.taskId);
        }
        // return this.handleSyncResponse(response.data.syncResult);
        var serverMessageList = response.data.syncResult.split('\r\n');
        return serverMessageList.map(function (serverMessage) { return serverMessage.split('\n'); });
    };
    MessageCenter.prototype.hasWaitAcceptCommand = function (message, type) {
        var _a;
        return !!((_a = message.waitAcceptCmd) === null || _a === void 0 ? void 0 : _a.includes(type));
    };
    MessageCenter.prototype.handleMessageResultSend = function (message, result) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var taskId, cmd, data;
            return __generator(this, function (_c) {
                taskId = message.taskId, cmd = message.cmd, data = message.data;
                message.onpostTime = websocket_channel_1.RoomUtil.getCurrentTime();
                // 异常处理
                if (this.shouldReconnect(result.errCode)) {
                    this.reconnect({
                        attrName: String(result.errCode),
                        reason: "save Error, retcode: " + result.errCode + ", msg: " + result.errMsg,
                    });
                    // 由业务方重试
                    this.messageSendQueue.remove(message.taskId);
                    return [2 /*return*/];
                }
                if (result.errCode !== 0) {
                    this.handleSendMessageError(message, result);
                    return [2 /*return*/];
                }
                (_a = message.onsend) === null || _a === void 0 ? void 0 : _a.call(message, taskId, cmd, data, result);
                if (!message.onsendAccept) {
                    // 不需要等待 ac 的消息，移除发送队列
                    this.messageSendQueue.remove(taskId);
                    this.trySendMessage();
                }
                else if ((_b = message.waitAcceptCmd) === null || _b === void 0 ? void 0 : _b.length) {
                    // 等待 ac 并且有 waitAcceptCmd 的，状态修改为 waitAccept 需要解析
                    message.state = websocket_channel_1.MessageState.WAIT_ACCEPT;
                }
                return [2 /*return*/];
            });
        });
    };
    MessageCenter.prototype.shouldReconnect = function (errCode) {
        return websocket_channel_1.NEED_RECONNECT_ERRCODES.includes(errCode);
    };
    MessageCenter.prototype.handleSendMessageError = function (message, result) {
        var _a;
        var taskId = message.taskId, cmd = message.cmd, data = message.data;
        (_a = message.onError) === null || _a === void 0 ? void 0 : _a.call(message, taskId, cmd, data, result);
        this.reportCommitError(message, result.errCode, "save Error, retcode: " + result.errCode + ", msg: " + result.errMsg);
        // 消息发送失败，移除发送队列
        this.messageSendQueue.remove(taskId);
        this.trySendMessage();
    };
    MessageCenter.prototype.handleMessageResultSendAccept = function (head, body) {
        var _a, _b, _c, _d, _e, _f;
        if (!head.task_id) {
            return;
        }
        var message = this.messageSendQueue.remove(head.task_id);
        if (!message || !this.hasWaitAcceptCommand(message, head.type)) {
            return;
        }
        this.reportCommitError(message, (_b = (_a = body.data) === null || _a === void 0 ? void 0 : _a.reason) !== null && _b !== void 0 ? _b : 0);
        var taskId = message.taskId, cmd = message.cmd, data = message.data, onsendAccept = message.onsendAccept;
        var type = head.type, newRev = head.new_rev;
        onsendAccept === null || onsendAccept === void 0 ? void 0 : onsendAccept(taskId, cmd, data, type, {
            errCode: (_d = (_c = body === null || body === void 0 ? void 0 : body.data) === null || _c === void 0 ? void 0 : _c.reason) !== null && _d !== void 0 ? _d : 0,
            errMsg: (_f = (_e = body === null || body === void 0 ? void 0 : body.data) === null || _e === void 0 ? void 0 : _e.msg) !== null && _f !== void 0 ? _f : '',
            response: {
                body: body,
                new_rev: newRev,
            },
        });
        // 同步发送的消息已 ac，启动发送下一条同步消息
        this.trySendSerialMessage();
    };
    /**
     * 服务端消息分发
     */
    MessageCenter.prototype.handleServerMessage = function (message) {
        var _a, _b;
        var _c = __read(message.map(function (item) { return util_1.JsonUtil.parseJson(item); }), 2), head = _c[0], body = _c[1];
        if (this.messageSendQueue.get(head.task_id)) {
            // 消息队列中存在消息 由messageCenter处理
            this.handleMessageResultSendAccept(head, body);
            return;
        }
        if ((head === null || head === void 0 ? void 0 : head.type) === "QUIT_NOTICE" /* QUIT_NOTICE */ && Object.values(type_1.QUIT_TYPE).includes(body === null || body === void 0 ? void 0 : body.notice.quit_type)) {
            var quitTypeMap = new Map([
                [type_1.QUIT_TYPE.INACTIVE, { code: websocket_channel_1.RoomWebsocketErrorCode.INACTIVE, reason: type_1.QUIT_TYPE.INACTIVE }],
                [type_1.QUIT_TYPE.LOGIN_INVALIDATE, { code: websocket_channel_1.RoomWebsocketErrorCode.LOGIN_INVALIDATE, reason: type_1.QUIT_TYPE.LOGIN_INVALIDATE }],
                [type_1.QUIT_TYPE.LOGIN_FORBIDDEN, { code: websocket_channel_1.RoomWebsocketErrorCode.LOGIN_FORBIDDEN, reason: type_1.QUIT_TYPE.LOGIN_FORBIDDEN }],
            ]);
            // 踢人消息
            this.connectManager.disconnect({
                reason: (_a = quitTypeMap.get(body === null || body === void 0 ? void 0 : body.notice.quit_type)) === null || _a === void 0 ? void 0 : _a.reason,
                errCode: (_b = quitTypeMap.get(body === null || body === void 0 ? void 0 : body.notice.quit_type)) === null || _b === void 0 ? void 0 : _b.code,
                shutDown: true,
            });
            return;
        }
        var serverMessage = {
            head: head,
            body: body,
            newRev: head.new_rev,
            ts: head.ts,
            needDeal: true,
        };
        this.limitFrequencyManager.handleMessage(serverMessage);
        if (serverMessage.needDeal) {
            this.dependency.receiveMessageFromServer(head.type, [serverMessage]);
        }
    };
    MessageCenter.prototype.handleWaitReconnecting = function () {
        this.handleDisconnect('WaitReconnecting');
        // 更新消息状态
        this.messageSendQueue.updateMessageState(websocket_channel_1.MessageState.WAITING);
    };
    MessageCenter.prototype.handleDisconnect = function (reason) {
        util_1.ConnectionLog.info(this.tag + " handleDisconnect reason:" + reason);
        this.receiver.stopToReceive();
        this.sender.clearAllRetryTimer();
        this.timeoutChecker.clearTimer();
        this.triggerAllMessagesClose();
    };
    MessageCenter.prototype.reconnect = function (reason) {
        var _a, _b;
        collab_room_reporter_1.default.reconnectReport({
            module: this.options.module,
            attrName: reason.attrName,
            status: 1 /* FAILED */,
            errorMessage: (_a = reason.reason) !== null && _a !== void 0 ? _a : websocket_channel_1.RoomUtil.getWebsocketChannelErrorMessage((_b = Number(reason.attrName)) !== null && _b !== void 0 ? _b : 0),
        });
        this.connectManager.reconnect();
    };
    MessageCenter.prototype.handleLogined = function (serverRequestParams) {
        this.serverRequestParams = serverRequestParams;
        if (!this.serverRequestParams.routeKey) {
            this.serverRequestParams.routeKey = this.options.serverVars.globalPadId;
        }
        this.receiver.receive();
    };
    MessageCenter.prototype.triggerAllMessagesClose = function () {
        this.triggerAllMessagesError({
            errCode: websocket_channel_1.RoomErrorCode.ROOM_CLOSE,
            errMsg: 'room close',
        });
    };
    MessageCenter.prototype.triggerAllMessagesShutdown = function () {
        this.triggerAllMessagesError({
            errCode: websocket_channel_1.RoomErrorCode.ROOM_SHUTDOWN,
            errMsg: 'room shutdown',
        });
    };
    MessageCenter.prototype.triggerAllMessagesError = function (errorResult) {
        var allMessages = this.messageSendQueue.filter(function (message) { return !!message; });
        allMessages.forEach(function (message) {
            var _a;
            var taskId = message.taskId, cmd = message.cmd, data = message.data;
            (_a = message.onError) === null || _a === void 0 ? void 0 : _a.call(message, taskId, cmd, data, errorResult);
        });
    };
    MessageCenter.prototype.reportCommitError = function (message, errCode, errMsg) {
        collab_room_reporter_1.default.commitError({
            attrName: String(errCode),
            status: 1 /* FAILED */,
            cmd: message.cmd,
            module: this.options.module,
            errorMessage: errMsg !== null && errMsg !== void 0 ? errMsg : websocket_channel_1.RoomUtil.getWebsocketChannelErrorMessage(errCode !== null && errCode !== void 0 ? errCode : 0),
            transports: 'big-collab',
        });
    };
    return MessageCenter;
}());
exports.MessageCenter = MessageCenter;
